import { onboardingGraph } from "@/data/onboarding";
import { Answers, FormattedAnswer } from "@/data/onboarding/types";
import { isAfter, differenceInYears } from "date-fns";

export const classnames = (stringArr: (string | undefined | boolean)[]) => {
  if (!stringArr || !stringArr.length) {
    return "";
  }

  return stringArr.filter(Boolean).join(" ");
};

export const calculateBmi = (height: number, weight: number) => {
  return weight / Math.pow(height / 100, 2);
};

export const toNumber = (numberString: string) => {
  return Number(numberString.replace(",", "."));
};

export const isSessionExpired = (session?: LoginResponse) => {
  if (!session) {
    return true;
  }

  const now = new Date();
  const expires = new Date(session.expires);

  return isAfter(now, expires);
};

export const getAgeFromPersonalNumber = (personalNumber?: string) => {
  if (!personalNumber) return;
  const year = Number(personalNumber.substring(0, 4));
  const month = Number(personalNumber.substring(4, 6));
  const day = Number(personalNumber.substring(6, 8));

  return differenceInYears(new Date(), new Date(year, month, day));
};

export const getTargetWeight = (height: number, targetBmi = 25) => {
  return Math.ceil(targetBmi * Math.pow(height / 100, 2));
};

export const capitalize = (str?: string) => {
  if (!str) {
    return "";
  }

  return str[0].toUpperCase() + str.slice(1);
};

export const getFormattedAnswers = (answers: Answers): FormattedAnswer[] => {
  const formattedAnswers: FormattedAnswer[] = [];

  Object.keys(answers).forEach((answer) => {
    if (answers[answer] === undefined) {
      return;
    }

    const graphNode = onboardingGraph[answer];
    if (!graphNode || !graphNode?.backendQuestionId) {
      return;
    }

    if (graphNode.skippable && answers[answer] === 0) {
      return;
    }

    if (graphNode.type === "boolean") {
      formattedAnswers.push({
        questionId: graphNode.backendQuestionId,
        answer: convertToAnswer(answers[answer]),
      });
    } else if (graphNode.type === "multiSelect") {
      formattedAnswers.push({
        questionId: graphNode.backendQuestionId,
        answer: answers[answer].toString().split(","),
      });
    } else {
      formattedAnswers.push({
        questionId: graphNode.backendQuestionId,
        answer: convertToAnswer(answers[answer]),
      });
    }
  });

  return formattedAnswers;
};

const convertToAnswer = (answer: string | number | boolean | string[]) => {
  if (typeof answer === "number") {
    return [answer === 1 ? "Ja" : answer === 0 ? "Nej" : "Vet ej"];
  }

  return [answer.toString()];
};

export const getBankIdUrl = (autostartToken: string, isIos: boolean) => {
  return `${isIos ? "https://app.bankid.com" : "bankid:///"}?autostarttoken=${autostartToken}`;
};

export function randomPick<T>(arr: T[]): T {
  if (arr.length === 0) {
    throw new Error("Array must not be empty");
  }

  const randomIndex = Math.floor(Math.random() * arr.length);
  return arr[randomIndex];
}
